import Modal from 'react-modal';
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import FormContent from './components/FormContent';

export class CardCopy extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  handleClose2 = () => {
    const {onClose} = this.props;
    onClose()
  };

  render() {
    const {formatMessage} = this.context;
    const {initialValues, open, createCard} = this.props;
    return (
      <Modal
        isOpen = {open}
        style = {{
            overlay : {zIndex: 999999},
        }}
        onRequestClose={this.handleClose2}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content ModalFormQbm"
      >
        <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('frmTitleCopyCard')}</div>
            <div
                onClick={this.handleClose2}
                className="create-dialog-modal-content__close"
            ></div>
        </div>
        <div className="create-dialog-modal-content__body">
          <FormContent initialValues={initialValues} handleClose2={this.handleClose2} createCard={createCard} />
        </div>
      </Modal>
    )
  }
}

export default CardCopy



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/CardCopy/CardCopy.jsx